<template>
    <div class="success step-success">
        <svg-vue class="add-show-success" icon="register-success" />
        <h2>Success!</h2>
        <p class="success-message">
            {{ message }}
        </p>
        <base-submit-button
            class="btn btn-primary"
            :disabled="processing"
            :loading="processing"
            @click="onSubmitClick"
        >
            {{ buttonLabel }}
        </base-submit-button>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: [Object],
            default: () => ({}),
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        messages: {
            hosted: 'Let’s upload your first episode.',
            migrate: 'We’re ready to start the migration process.<br>This will only take a few minutes.',
            default: 'Let’s start customizing your Fusebox players.',
            'hosting-cancel': 'Your Easy Hosting has been successfully cancelled.',
            downgrade: 'Your Plan has been downgraded.',
        },
        buttonLabels: {
            hosted: 'Start Podcasting',
            migrate: 'Start Podcast Migration',
            default: 'See your Podcast',
            'hosting-cancel': 'Back to Dashboard',
        },
    }),

    computed: {
        /**
         * Returns type of success components.
         *
         * @returns {string} Type of components.
         */
        type() {
            return this.data.mode ||
                ('hosted' === this.data.type ? 'hosted' : 'default');
        },

        /**
         * Returns message text based on current mode/type.
         *
         * @returns {string} Message text.
         */
        message() {
            return this.messages[this.type] || this.messages.default;
        },

        /**
         * Returns button label based on current mode/type.
         *
         * @returns {string} Button label.
         */
        buttonLabel() {
            return this.buttonLabels[this.type] || this.buttonLabels.default;
        },
    },

    methods: {
        /**
         * Handles click on submit button.
         */
        onSubmitClick() {
            this.$emit('click');
            this.$emit('proceed', this.data);
        },
    },
};
</script>
